import React from 'react';
import { BackupConfigProps } from './types';

interface GeneralSettingsProps {
  config: BackupConfigProps['config'];
  onConfigChange: BackupConfigProps['onConfigChange'];
}

const GeneralSettings: React.FC<GeneralSettingsProps> = ({ config, onConfigChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-sm font-medium text-slate-900 dark:text-slate-100">
            Enable Backups
          </h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Automatically create backups for DNS operations
          </p>
        </div>
        <input
          type="checkbox"
          checked={config.enabled}
          onChange={(e) => onConfigChange({ ...config, enabled: e.target.checked })}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-slate-300 rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
          Retention Period (days)
        </label>
        <input
          type="number"
          value={config.retentionDays}
          onChange={(e) =>
            onConfigChange({ ...config, retentionDays: parseInt(e.target.value || '0', 10) })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
          Max Backups per Zone
        </label>
        <input
          type="number"
          value={config.maxBackupsPerZone}
          onChange={(e) =>
            onConfigChange({
              ...config,
              maxBackupsPerZone: parseInt(e.target.value || '0', 10),
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
          Compression Level (0-9)
        </label>
        <input
          type="range"
          min="0"
          max="9"
          value={config.compressionLevel}
          onChange={(e) =>
            onConfigChange({ ...config, compressionLevel: parseInt(e.target.value, 10) })
          }
          className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer"
        />
        <div className="flex justify-between text-xs text-slate-500 dark:text-slate-400 mt-1">
          <span>No compression</span>
          <span>{config.compressionLevel}</span>
          <span>Max compression</span>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-sm font-medium text-slate-900 dark:text-slate-100">
            Auto Backup
          </h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Create backups before destructive operations
          </p>
        </div>
        <input
          type="checkbox"
          checked={config.autoBackup}
          onChange={(e) => onConfigChange({ ...config, autoBackup: e.target.checked })}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-slate-300 rounded"
        />
      </div>
    </div>
  );
};

export default GeneralSettings;